import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { CircularProgress, makeStyles } from '@material-ui/core'
import { useClientSummary, useFeeSchedule } from '../../../../../api/billing'
import DebouncedInput from '../../../../molecules/DebouncedInput'
import { Blade } from './shared/Blade'
import MiniTable from './MiniTable'

const useStyles = makeStyles((theme) => ({
  clientItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.layout.gap.medium,
    border: `1px solid ${theme.palette.gray.dark}`,
    padding: theme.layout.padding.thin,
    borderRadius: theme.layout.radius.tight,
    marginBottom: theme.layout.margin.thin
  }
}))

const clientKeyAccessor = client => client?.clientId

function ClientBlade ({ selected, onSelect, baseQuery, columns, filterOn }) {
  const classes = useStyles()
  const { data, isLoading, error } = useClientSummary(baseQuery)
  useFeeSchedule()
  const [filter, setFilter] = useState('')
  const summary = useMemo(() => {
    const lowerFilter = filter.toLowerCase()
    return (data || []).filter(x => !lowerFilter || (filterOn || []).reduce((prev, cur) => {
      const val = get(x, cur.accessor)?.toString()?.toLowerCase()
      // eslint-disable-next-line eqeqeq
      const res = cur.exact ? val == lowerFilter : val.includes(lowerFilter)
      return prev || res
    }, false))
  }, [filter, data, filterOn])

  if (error) {
    return (
      <div className={classes.blade}>
        Sorry, there was an error loading this view
      </div>
    )
  }

  if (isLoading) {
    return (
      <div className={classes.blade}>
        <CircularProgress />
      </div>
    )
  }

  return (
    <Blade>
      <div>
        <DebouncedInput onChange={setFilter} delay={100} />
      </div>
      <MiniTable
        data={summary}
        columns={columns}
        keyAccessor={clientKeyAccessor}
        onSelect={onSelect}
        selected={selected}
      />
    </Blade>
  )
}

ClientBlade.propTypes = {
  selected: PropTypes.any,
  onSelect: PropTypes.func,
  baseQuery: PropTypes.object,
  columns: PropTypes.array,
  filterOn: PropTypes.array
}

ClientBlade.defaultProps = {
  filterOn: [
    { accessor: 'clientId', exact: true },
    { accessor: 'longName' }
  ]
}

export default ClientBlade
